/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OverrideAnalysisResultRequest
 */
export interface OverrideAnalysisResultRequest {
    /**
     * The new criteria result to override with
     * @type {string}
     * @memberof OverrideAnalysisResultRequest
     */
    criteria_result: OverrideAnalysisResultRequestCriteriaResultEnum;
    /**
     * The reason for overriding the analysis result
     * @type {string}
     * @memberof OverrideAnalysisResultRequest
     */
    override_reason: OverrideAnalysisResultRequestOverrideReasonEnum;
    /**
     * Additional comment explaining the override
     * @type {string}
     * @memberof OverrideAnalysisResultRequest
     */
    comment: string;
}


/**
 * @export
 */
export const OverrideAnalysisResultRequestCriteriaResultEnum = {
    Pass: 'Pass',
    Fail: 'Fail',
    Unknown: 'Unknown',
    NA: 'N/A'
} as const;
export type OverrideAnalysisResultRequestCriteriaResultEnum = typeof OverrideAnalysisResultRequestCriteriaResultEnum[keyof typeof OverrideAnalysisResultRequestCriteriaResultEnum];

/**
 * @export
 */
export const OverrideAnalysisResultRequestOverrideReasonEnum = {
    IncompleteOrMissingPatientData: 'Incomplete or missing patient data',
    NewInformationReceived: 'New information received',
    AiReasoningIssues: 'AI reasoning issues',
    AiExtractionOrReadingError: 'AI extraction or reading error',
    ClinicalJudgmentDiffers: 'Clinical judgment differs'
} as const;
export type OverrideAnalysisResultRequestOverrideReasonEnum = typeof OverrideAnalysisResultRequestOverrideReasonEnum[keyof typeof OverrideAnalysisResultRequestOverrideReasonEnum];


/**
 * Check if a given object implements the OverrideAnalysisResultRequest interface.
 */
export function instanceOfOverrideAnalysisResultRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "criteria_result" in value;
    isInstance = isInstance && "override_reason" in value;
    isInstance = isInstance && "comment" in value;

    return isInstance;
}

export function OverrideAnalysisResultRequestFromJSON(json: any): OverrideAnalysisResultRequest {
    return OverrideAnalysisResultRequestFromJSONTyped(json, false);
}

export function OverrideAnalysisResultRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OverrideAnalysisResultRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'criteria_result': json['criteria_result'],
        'override_reason': json['override_reason'],
        'comment': json['comment'],
    };
}

export function OverrideAnalysisResultRequestToJSON(value?: OverrideAnalysisResultRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'criteria_result': value.criteria_result,
        'override_reason': value.override_reason,
        'comment': value.comment,
    };
}

